import Helpers from '@Apis/helpers';
import Constants from '@Apis/constants';

/**
 * @param sku
 * @param orgId
 * @param sellerId
 * @param tenantId
 * @param page
 * @param limit
 * @param payload
 */
class SellerService {
  /**
   *
   * @param pincode
   * @return {Promise<unknown>}
   */
  getCityState = async (pincode) => new Promise((resolve, reject) => {
    fetch(`https://api.postalpincode.in/pincode/${pincode}`, { method: 'GET' })
      .then((response) => response)
      .then((response) => [response.json(), response.status])
      .then(([response, status]) => {
        if (status >= 200 && status <= 300) {
          response.then((result) => {
            if (result[0].Status === 'Success') {
              const pincodeInfo = result[0].PostOffice[0];
              const cityStateInfo = {
                pincodeCity: pincodeInfo.District,
                pincodeState: pincodeInfo.State,
              };
              resolve(cityStateInfo);
            } else {
              reject(new Error('Invalid area code'));
            }
          });
        } else {
          return [response, status];
        }
      })
      .catch((error) => reject(error.message));
  })

  /**
   * @param page
   * @param keyword
   * @param orgId
   * @param limit
   * @param sellerId
   * @param tenantSellerId
   * @param isActive
   * @param tenantId
   * @return {Promise<*>}
   */
  getSellers = async (keyword, tenantId, page, limit, sellerId, isActive, isSubcontractor, sellerType, isMarketplaceSeller, selectedSellerIds, excludeSellerIds, advanceFilters) => {
    let url = `${Constants.SELLERS}?`;
    if (keyword) url += `seller_name=${keyword}&`;
    if (tenantId) url += `tenant_id=${tenantId}&`;
    if (page) url += `page=${page}&`;
    if (limit) url += `limit=${limit}&`;
    if (sellerId) url += `seller_id=${sellerId}&`;
    if (isActive) url += `is_active=${isActive}&`;
    if (isSubcontractor) url += `is_subcontractor=${isSubcontractor}&`;
    if (sellerType) url += `seller_type=${sellerType}&`;
    if (isMarketplaceSeller) url += `is_marketplace_seller=${isMarketplaceSeller}&`;
    if (selectedSellerIds) url += `selected_seller_ids=${selectedSellerIds}&`;
    if (excludeSellerIds) url += `exclude_seller_ids=${excludeSellerIds}&`;
    if (advanceFilters) url += `advanced_filter=${advanceFilters}&`;
    const sellers = await Helpers.get({ url });
    return sellers;
  }

  /**
   * @param orgId
   * @param sellerId
   * @param tenantId
   * @param page
   * @param limit
   * @param sellerName
   * @return {Promise<*>}
   */
  getOrgSellers = async (orgId, sellerId, tenantId, page, limit, sellerName, isVendorArchive) => {
    let url = `${Constants.SELLERS}/seller_tenants?`;
    if (orgId) url += `org_id=${orgId}&`;
    if (sellerId) url += `seller_id=${sellerId}&`;
    if (tenantId) url += `tenant_id=${tenantId}`;
    if (page) url += `page=${page}&`;
    if (limit) url += `limit=${limit}&`;
    if (sellerName) url += `seller_name=${sellerName}&`;
    if (isVendorArchive) url += `is_archive=${isVendorArchive}&`;
    const sellers = await Helpers.get({ url });
    return sellers;
  }

  /**
   * @param sellerId
   * @param tenantId
   * @return {Promise<*>}
   */
  getSellerById = async (sellerId, tenantId) => {
    const sellers = await Helpers.get({
      url: `${Constants.SELLERS}?seller_id=${sellerId}&tenant_id=${tenantId}`,
    });
    return sellers;
  }

  /**
   *
   * @param payload
   * @return {Promise<void>}
   */
  createSeller = async (payload) => {
    const createdSeller = await Helpers.post({
      url: Constants.SELLERS,
      data: payload,
    });
    return createdSeller;
  }

  /**
   * @param payload
   * @return {Promise<*>}
   */
  updateSeller = async (payload) => {
    const seller = await Helpers.put({
      url: Constants.SELLERS,
      data: payload,
    });
    return seller;
  }

  /**
   *
   * @param sellerId
   * @return {Promise<*>}
   */
  deleteSeller = async (sellerId) => {
    const seller = await Helpers.delete({
      url: `${Constants.DELETE_SELLER}?seller_id=${sellerId}`,
    });
    return seller;
  }

  /**
   * @param sellerId
   * @param tenantId
   * @param page
   * @return {Promise<*>}
   */
  getSellerOffersById = async (sellerId, tenantId, page) => {
    const seller = await Helpers.get({
      url: `${Constants.GET_SELLER_OFFERS}?seller_id=${sellerId}&page=${page}&limit=10${tenantId ? `&tenant_id=${tenantId}` : ''}`,
    });
    return seller;
  }

  /**
   *
   * @param payload
   * @return {Promise<*>}
   */
  updateSellerOffers = async (payload) => {
    const seller = await Helpers.put({
      url: Constants.OFFERS,
      data: payload,
    });
    return seller;
  }
  /**
 * @param {*} orgId
 * @param {*} tenantIds
 * @param {*} fromDate
 * @param {*} toDate
 * @param firstSubUrl
 * @param secondSubUrl
 * @param type
 * @param {*} reportName
 * @return
 */

  getReports = async (firstSubUrl, secondSubUrl, tenantId, tenantSellerId, fromDate, toDate, customerId) => {
    const formDateWithoutMilliSec = Number((fromDate / 1000).toFixed(0));
    const toDateWithoutMilliSec = Number((toDate / 1000).toFixed(0));

    let url = `${Constants.SELLERS}/`;
    if (firstSubUrl) url += `${firstSubUrl}?`;
    if (tenantId) url += `tenant_id=${tenantId}&`;
    if (tenantSellerId) url += `seller_id=${tenantSellerId}&`;
    if (fromDate) url += `from=${(formDateWithoutMilliSec)}&`;
    if (toDate) url += `to=${toDateWithoutMilliSec}&`;
    if (customerId) url += `customer_id=${customerId}&`;
    const reportsSeller = await Helpers.get({
      url,
    });

    return reportsSeller;
  }

  /**
     * @param {*} firstSubUrl
     * @param {*} secondSubUrl
     * @param {*} orgId
     * @param {*} tenantIds
     * @param {*} fromDate
     * @param {*} toDate
     * @param fileReportType
     * @param reportName
     * @param {*} type
     * @param {*} sellerId
     * @return
     */
  getReportsDownload = async (firstSubUrl, secondSubUrl, tenantId, tenantSellerId, fromDate, toDate, fileReportType) => {
    const formDateWithoutMilliSec = Number((fromDate / 1000).toFixed(0));
    const toDateWithoutMilliSec = Number((toDate / 1000).toFixed(0));
    let url = `${Constants.SELLERS_REPORT_DOWNLOAD}/`;
    if (firstSubUrl) url += `${firstSubUrl}?`;
    if (tenantId) url += `tenant_id=${tenantId}&`;
    if (tenantSellerId) url += `tenant_seller_id=${tenantSellerId}&`;
    if (fromDate) url += `from=${formDateWithoutMilliSec}&`;
    if (toDate) url += `to=${toDateWithoutMilliSec}&`;
    if (fileReportType) url += `type=${fileReportType}&`;
    const reportsSeller = await Helpers.getFile({
      url,
    });
    return reportsSeller;
  }

  /**
     * @param payload
     * @return {Promise<*>}
     */
  sendAccountStatementMail = async (payload) => {
    const seller = await Helpers.post({
      url: Constants.SEND_ACCOUNT_STATEMENT_MAIL,
      data: payload,
    });
    return seller;
  }

  /**
   *
   * @param payload
   * @returns {Promise<*>}
   */
  linkCustomer = async (payload) => {
    const linkedCustomer = await Helpers.post({
      url: `${Constants.CUSTOMERS}/link-vendor`,
      data: payload,
    });
    return linkedCustomer;
  }

  /**
   *
   * @returns {Promise<*>}
   */
  getBulkUploadSellerMetadata = async () => {
    const url = `${Constants.SELLERS}/bulk-upload/metadata`;
    const bulkUpload = await Helpers.get({
      url,
    });
    return bulkUpload;
  }

  bulkUploadSellers = async (payload) => {
    const url = `${Constants.SELLERS}/bulk-upload`;
    const data = new FormData();
    data.append('file', payload?.file);
    data.append('column_mapping', JSON.stringify(payload?.columnMapping));
    data.append('tenant_ids', payload?.tenants);

    const bulkUpload = await Helpers.filePost({
      url,
      file: data,
    });
    return bulkUpload;
  }

  bulkUpdateSellers = async (payload) => {
    const url = `${Constants.SELLERS}/bulk-update`;
    const data = new FormData();
    data.append('file', payload?.file);
    data.append('column_mapping', JSON.stringify(payload?.columnMapping));
    data.append('tenant_ids', payload?.tenants);
    data.append('current_tenant_id', payload.current_tenant_id);

    const bulkUpdate = await Helpers.filePost({
      url,
      file: data,
    });
    return bulkUpdate;
  }

  getTallySellers = async (itId, orgId, searchKeyword, selectedSeller) => {
    let url = `${Constants.GET_TALLY_SELLERS}?`;
    if (itId) url += `it_id=${itId}&`;
    if (orgId) url += `org_id=${orgId}&`;
    if (searchKeyword) url += `search_keyword=${searchKeyword}&`;
    if (selectedSeller) url += `selected_tally_seller_id=${selectedSeller}&`;
    const getTallySellers = await Helpers.get({ url });
    return getTallySellers;
  }
}
export default new SellerService();
